import type { Competency } from '@/types/interview'

export const COMPETENCY_LABELS: Record<Competency, string> = {
  leadership: 'Leadership',
  teamwork: 'Teamwork',
  communication: 'Communication',
  problem_solving: 'Problem Solving',
  time_management: 'Time Management',
  stakeholder_management: 'Stakeholder Management',
  attention_to_detail: 'Attention to Detail',
}
